<template>
    <div class="layout__container mt-auto pb-20px">
        <div class="layout__padding-clear">
            <div class="layout__padding-clear layout__margin__top-40">
                <div class="colour__background-light-grey layout__overflow-hidden layout__padding-40px-0 text__line-height-15">

                    <!--<div class="layout__padding-clear layout__width-80 text__align-center">-->
                        <!--<div class="">-->
                            <!--<div class="layout__width-30 layout__position-left">-->
                                <!--<h4 class="text__colour-teal text__align-left">Sign up to our newsletter for special-->
                                    <!--offers and product updates</h4>-->
                            <!--</div>-->


                            <!--<div id="sendgrid-subscription-widget" class="sendgrid-subscription-widget"-->
                                 <!--data-emailerror="Please enter a valid email address"-->
                                 <!--data-nameerror="Please enter your name"-->
                                 <!--data-checkboxerror="Please tick the box to accept our conditions">-->
                                <!--<form id="sg-widget" data-token="024a96848784ec87a94bf1c8e0c52869"-->
                                      <!--onsubmit="return false;">-->
                                    <!--<span class="layout__width-50 layout__position-left">-->
                                        <!--<input id="sg_email" type="email" name="sg_email" placeholder="you@example.com" required="required"-->
                                        <!--class="layout__width-90">-->
                                    <!--</span>-->
                                        <!--<input type="submit" class="button__base button-teal layout__width-150px"-->
                                               <!--id="sg-submit-btn" value="Subscribe">-->
                                <!--</form>-->
                            <!--</div>-->

                            <!--<div class="text__align-center layout__width-100">-->
                                <!--<div class="font__size-14 text__colour-teal" id="sg-response"></div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
            </div>

            <div class="layout__border__bottom__top">
                <div class="layout__padding-clear layout__width-95 layout__height-30px">
                    <!--<span class="layout__position-right icon-twitter text__size-30 text__colour-teal layout__padding__left-20px"></span>-->
                    <a href="https://twitter.com/RavensworthUK" target="_blank" class="layout__margin__top-10"><h2
                            class="icon-twitter text__align-center layout__position-right text__size-30 text__colour-teal layout__padding__left-20px"></h2>
                    </a>
                    <a href="https://www.facebook.com/ravensworthUK/" target="_blank"
                       class="layout__margin__top-10"><h2
                            class="icon-facebook text__align-center layout__position-right text__size-30 text__colour-teal"></h2>
                    </a>
                </div>
            </div>

            <div class="layout__padding-clear">
                <div class="text__align-center layout__margin__top-30">
                    <div class="text__size-12 layout__margin__top-10">
                        <a href="https://www.myravensworth.co.uk/about" target="_blank"
                           class="component__footer__subtitles link__colour-black"
                           rel="nofollow noopener">Ravensworth</a>
                        &emsp; | &emsp;
                        <a href="http://ravensworth.co.uk/terms-and-conditions/" target="_blank"
                           class="component__footer__subtitles link__colour-black" rel="nofollow noopener">Terms of
                            use</a>
                        &emsp; | &emsp;
                        <a href="http://ravensworth.co.uk/privacy-policy/" target="_blank"
                           class="component__footer__subtitles link__colour-black" rel="nofollow noopener">Privacy
                            Policy</a>
                        &emsp; | &emsp;
                        <a href="http://ravensworth.co.uk/cookie-policy/" target="_blank"
                           class="component__footer__subtitles link__colour-black" rel="nofollow noopener">Cookie
                            Policy</a>
                    </div>

                    <div class="layout__position-center text__align-center layout__margin__top-20 text__line-height-2 layout__padding__bottom-20">
                        <div class="component__footer__terms-and-conditions layout__margin__top-10">
                          version: {{version}} &#169; 2021 The Printed Group Limited trading as Ravensworth Printing Services
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footer",
        data() {
            return {
                version: `${process.env.VUE_APP_VERSIONNUMBER}`,
                register: '',
                rules: {}
            }
        },
        created() {
        },
        methods: {},
    };
</script>